import { render, staticRenderFns } from "./PageSeoCreateForm.vue?vue&type=template&id=79ea3f11&"
import script from "./PageSeoCreateForm.vue?vue&type=script&lang=js&"
export * from "./PageSeoCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports